export type PaginationPageItem =
	| { type: "page"; page: number }
	| { type: "ellipsis"; key: string };

const EDGE_WINDOW = 8;

function range(start: number, end: number): PaginationPageItem[] {
	return Array.from({ length: end - start + 1 }, (_, index) => ({
		type: "page" as const,
		page: start + index,
	}));
}

export function buildPaginationPageItems(
	currentPage: number,
	totalPages: number,
): PaginationPageItem[] {
	if (totalPages <= 1) {
		return [];
	}

	if (totalPages <= EDGE_WINDOW + 1) {
		return range(1, totalPages);
	}

	if (currentPage <= EDGE_WINDOW) {
		return [
			...range(1, EDGE_WINDOW),
			{ type: "ellipsis", key: "end-ellipsis" },
			{ type: "page", page: totalPages },
		];
	}

	if (
		currentPage >= totalPages - EDGE_WINDOW + 1 &&
		currentPage > EDGE_WINDOW + 1
	) {
		return [
			{ type: "page", page: 1 },
			{ type: "ellipsis", key: "start-ellipsis" },
			...range(totalPages - EDGE_WINDOW + 1, totalPages),
		];
	}

	const middleStart = currentPage - 1;
	const middleEnd = currentPage + 1;

	return [
		{ type: "page", page: 1 },
		{ type: "ellipsis", key: "start-ellipsis" },
		...range(middleStart, middleEnd),
		{ type: "ellipsis", key: "end-ellipsis" },
		{ type: "page", page: totalPages },
	];
}
